/**
 * YHC社 エリアマスタ
 * - sort: ドロップダウン等の表示順（Object.keys は '10' 等を整数キー扱いにするため順序が崩れる）
 */
export const yhcAreasByCode = {
  '01': { name: '道東', short: '道東', prefName: '北海道', sort: 1 },
  '48': { name: '道北', short: '道北', prefName: '北海道', sort: 2 },
  '49': { name: '札幌', short: '札幌', prefName: '北海道', sort: 3 },
  '50': { name: '函館', short: '函館', prefName: '北海道', sort: 4 },
  '02': { name: '青森県', short: '青森', sort: 5 },
  '03': { name: '岩手県', short: '岩手', sort: 6 },
  '04': { name: '宮城県', short: '宮城', sort: 7 },
  '05': { name: '秋田県', short: '秋田', sort: 8 },
  '06': { name: '山形県', short: '山形', sort: 9 },
  '07': { name: '福島県', short: '福島', sort: 10 },
  '08': { name: '茨城県', short: '茨城', sort: 11 },
  '09': { name: '栃木県', short: '栃木', sort: 12 },
  '10': { name: '群馬県', short: '群馬', sort: 13 },
  '11': { name: '埼玉県', short: '埼玉', sort: 14 },
  '12': { name: '千葉県', short: '千葉', sort: 15 },
  '13': { name: '東京都', short: '東京', sort: 16 },
  '14': { name: '神奈川県', short: '神奈川', sort: 17 },
  '15': { name: '新潟県', short: '新潟', sort: 18 },
  '16': { name: '富山県', short: '富山', sort: 19 },
  '17': { name: '石川県', short: '石川', sort: 20 },
  '18': { name: '福井県', short: '福井', sort: 21 },
  '19': { name: '山梨県', short: '山梨', sort: 22 },
  '20': { name: '長野県', short: '長野', sort: 23 },
  '21': { name: '岐阜県', short: '岐阜', sort: 24 },
  '22': { name: '静岡県', short: '静岡', sort: 25 },
  '23': { name: '愛知県', short: '愛知', sort: 26 },
  '24': { name: '三重県', short: '三重', sort: 27 },
  '25': { name: '滋賀県', short: '滋賀', sort: 28 },
  '26': { name: '京都府', short: '京都', sort: 29 },
  '27': { name: '大阪府', short: '大阪', sort: 30 },
  '28': { name: '兵庫県', short: '兵庫', sort: 31 },
  '29': { name: '奈良県', short: '奈良', sort: 32 },
  '30': { name: '和歌山県', short: '和歌山', sort: 33 },
  '31': { name: '鳥取県', short: '鳥取', sort: 34 },
  '32': { name: '島根県', short: '島根', sort: 35 },
  '33': { name: '岡山県', short: '岡山', sort: 36 },
  '34': { name: '広島県', short: '広島', sort: 37 },
  '35': { name: '山口県', short: '山口', sort: 38 },
  '36': { name: '徳島県', short: '徳島', sort: 39 },
  '37': { name: '香川県', short: '香川', sort: 40 },
  '38': { name: '愛媛県', short: '愛媛', sort: 41 },
  '39': { name: '高知県', short: '高知', sort: 42 },
  '40': { name: '福岡県', short: '福岡', sort: 43 },
  '41': { name: '佐賀県', short: '佐賀', sort: 44 },
  '42': { name: '長崎県', short: '長崎', sort: 45 },
  '43': { name: '熊本県', short: '熊本', sort: 46 },
  '44': { name: '大分県', short: '大分', sort: 47 },
  '45': { name: '宮崎県', short: '宮崎', sort: 48 },
  '46': { name: '鹿児島県', short: '鹿児島', sort: 49 },
  '47': { name: '沖縄県', short: '沖縄', sort: 50 },
} as const

export type YhcAreaCode = keyof typeof yhcAreasByCode

/** sort 昇順のエリアコード一覧（表示順用） */
export const yhcAreaCodesInDisplayOrder: YhcAreaCode[] = (
  Object.keys(yhcAreasByCode) as YhcAreaCode[]
).sort((a, b) => yhcAreasByCode[a].sort - yhcAreasByCode[b].sort)

export const yhcAreaCodes = Object.keys(yhcAreasByCode).sort(
  (a, b) => parseInt(a) - parseInt(b),
)

export const yhcAreaCodesByNames = Object.keys(yhcAreasByCode).reduce((acc, code) => {
  acc[yhcAreasByCode[code].name] = code
  return acc
}, {} as Record<string, string>)
export const yhcAreaCodesByShortNames = Object.keys(yhcAreasByCode).reduce(
  (acc, code) => {
    acc[yhcAreasByCode[code].short] = code
    return acc
  },
  {} as Record<string, string>,
)

export const yhcAreaIsInHokkaido = (areaCode: string) => {
  return ['01', '48', '49', '50'].includes(areaCode)
}

export const yhcAreaIsInOkinawa = (areaCode: string) => {
  return areaCode == '47'
}

/**
 * 管理画面表示用: コードの後ろにエリア名を付ける（保存値はコードのまま）
 * 例: "06" → "06 (山形県)", "01" → "01 (道東)"
 */
export const formatYhcAreaCodeWithName = (code: string | null | undefined): string => {
  if (code == null) return ''
  const trimmed = String(code).trim()
  if (!trimmed) return ''
  const area = yhcAreasByCode[trimmed as YhcAreaCode]
  if (!area) return trimmed
  return `${trimmed} (${area.name})`
}

/** 管理画面の selections 用（sort 昇順、ラベルはコード + 名称） */
export const buildYhcAreaCodeWithNameSelections = (): { label: string; value: string }[] => {
  return yhcAreaCodesInDisplayOrder.map((code) => ({
    label: formatYhcAreaCodeWithName(code),
    value: code,
  }))
}
